export default __webpack_public_path__ + "smop-favicon-184.930b16a9fd66e8d8f69a610559b9dccd.png";